import { isFilled, isRuPhoneNumber, isEmail } from '~utils/validators';
import { Props as InputProps } from '~components/Input';
import useForm, {
  FormConfig,
  ReturnValueType as UseFormReturnValueType,
} from './useForm';

export type ContactFormFieldNames = 'phone' | 'email' | 'name' | 'date';

type Params = {
  fieldNames: ContactFormFieldNames[];
  defaultValues?: Record<ContactFormFieldNames, string>;
};

type ReturnValueType = {
  form: UseFormReturnValueType<ContactFormFieldNames>;
  inputProps: InputProps<ContactFormFieldNames>[];
};

const defaultInputPropsByName: Record<
  ContactFormFieldNames,
  Partial<InputProps<ContactFormFieldNames>>
> = {
  name: {
    placeholder: 'Вашe имя',
  },
  phone: {
    placeholder: 'Ваш телефон',
  },
  email: {
    placeholder: 'Ваш e-mail',
  },
  date: {
    placeholder: 'Дата просмотра',
  },
};

const useContactForm = ({
  fieldNames,
  defaultValues,
}: Params): ReturnValueType => {
  const { phone = '', email = '', name = '', date = '' } = defaultValues || {};

  // eslint-disable-next-line ~typescript-eslint/no-object-literal-type-assertion
  const formConfig = {} as FormConfig<ContactFormFieldNames>;

  fieldNames.forEach((fieldName) => {
    if (fieldName === 'phone') {
      formConfig.phone = {
        value: phone,
        validators: [isRuPhoneNumber],
      };
    }

    if (fieldName === 'email') {
      formConfig.email = {
        value: email,
        validators: [isEmail],
      };
    }

    if (fieldName === 'name') {
      formConfig.name = {
        value: name,
        validators: [isFilled],
      };
    }

    if (fieldName === 'date') {
      formConfig.date = {
        value: date,
        validators: [isFilled],
      };
    }
  });

  const form = useForm(formConfig);

  return {
    form,
    inputProps: (Object.keys(formConfig) as Array<keyof typeof formConfig>).map(
      (key) => {
        return {
          name: key,
          value: form.formData[key],
          onChange: form.handleChange,
          onBlur: form.handleBlur,
          hasError: !form.formState[key].isValid,
          ...defaultInputPropsByName[key],
        };
      },
    ),
  };
};

export default useContactForm;
